// frequencyList, defaultFrequency, modalDarkTheme, defaultSelectedTickers, tickerPattern
export const defualtErrorMessage =
  "Something went wrong please try again later";

export const graphColorList = [
  "#315bbc",
  "#db5943",
  "#41bc66",
  "#bf8523",
  "#e377c2",
  "#17becf",
  "#2ca02c",
  "#ff7f0e",
  "#485c7b",
  "#71649C",
];

export const defaultFrequency = { label: "D", value: "D" };

export const frequencyList = [
  { label: "D", value: "D" },
  { label: "W", value: "W" },
  { label: "M", value: "M" },
];

export const defaultGraphStyle = {
  lineType: "solid", // Type of line: can be 'solid', 'dotted', or 'dashed'
  color: "#315bbc", // Color for the line, will be defined dynamically
  opacity: "1", // Line opacity: from 0 (transparent) to 1 (opaque)
  width: "2", // Line width in pixels
  priceScalePosition: "left", // Position of the price scale, can be 'left' or 'right'
  crosshairColor: "#00ff00", // Color of the crosshair on the chart
  crossHairMarkerVisible: true, // Whether the crosshair marker is visible when hovering
  priceLineVisible: true, // Whether the last price line is visible on the chart
  lastValueVisible: true, // Whether the last value is visible on the price scale
  gridLineColor: "#f0f0f0", // Color of the grid lines in the chart
  showTitleOnPriceScale: true,
};

export const defaultAllTickersOptions = [
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "HDFCBANK",
    name: "Hdfc Bank",
    type: "Common Stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "0P00009J3K",
    name: "Hdfc Mid-cap Opportunities Fund Growth",
    type: "fund",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "0P0000XVOU",
    name: "Tata Ethical Fund Direct Plan Growth",
    type: "fund",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "0P0000XVPU",
    name: "Taurus Ethical Fund-direct Plan Growth",
    type: "fund",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "0P0000YWL0",
    name: "Parag Parikh Flexi Cap Regular Growth",
    type: "fund",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "20MICRONS",
    name: "20 Microns Limited",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "21STCENMGM",
    name: "21st Century Management Services Limited",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "360ONE",
    name: "360 ONE WAM LIMITED",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "3IINFOLTD",
    name: "3i Infotech Limited",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "3MINDIA",
    name: "3M India Limited",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "HDFCBANK-NSE",
    code: "3PLAND",
    name: "3P Land Holdings Limited",
    type: "common_stock",
    sub_type: "ohlc",
    exchange: "NSE",
    country: "India",
  },
  {
    unique_identifier: "M_EPC50G_FPF_SOH_MBBLD-petroleum/crd/api/data",
    code: "M_EPC50G_FPF_SOH_MBBLD",
    name: "Ohio Crude Oil and Lease Condensate Production for 50.1 or Higher Degrees API Gravity (Thousand Barrels per Day)",
    type: "macro",
    sub_type: "eia",
    exchange: "eia",
    country: "unknown",
  },
  {
    unique_identifier: "WG1TP_NUS_2-petroleum/pnp/wprodrb/data",
    code: "WG1TP_NUS_2",
    name: "U.S. Refiner and Blender Net Production of Finished Reformulated Motor Gasoline with Ethanol (Thousand Barrels per Day)",
    type: "macro",
    sub_type: "eia",
    exchange: "eia",
    country: "unknown",
  },
  {
    unique_identifier: "MOCLEUS2-petroleum/pnp/unc/data",
    code: "MOCLEUS2",
    name: "U. S. Operable Crude Oil Distillation Capacity (Thousand Barrels per Calendar Day)",
    type: "macro",
    sub_type: "eia",
    exchange: "eia",
    country: "unknown",
  },
  {
    unique_identifier: "M_EPC50G_FPF_SKS_MBBLD-petroleum/crd/api/data",
    code: "M_EPC50G_FPF_SKS_MBBLD",
    name: "Kansas Crude Oil and Lease Condensate Production for 50.1 or Higher Degrees API Gravity (Thousand Barrels per Day)",
    type: "macro",
    sub_type: "eia",
    exchange: "eia",
    country: "unknown",
    created_at: "2024-10-24 06:26:21.308",
    updated_at: "2024-10-24 06:26:21.311",
  },
  {
    unique_identifier: "EXPINF8YR-32455",
    code: "EXPINF8YR",
    name: "8-Year Expected Inflation",
    type: "macro",
    sub_type: "fred",
    exchange: "fred",
    country: "unknown",
  },
  {
    unique_identifier: "A36CVS-32430",
    code: "A36CVS",
    name: "Manufacturers' Value of Shipments: Heavy Duty Truck Manufacturing",
    type: "macro",
    sub_type: "fred",
    exchange: "fred",
    country: "unknown",
  },
  {
    unique_identifier: "mac_ser_prices",
    code: "mac_ser_prices",
    name: "Services PMI Prices Index",
    type: "macro",
    sub_type: "pmi",
    exchange: "pmi",
    country: "unknown",
  },
  {
    unique_identifier: "mac_man_employment",
    code: "mac_man_employment",
    name: "Manufacturing Employment Index",
    type: "macro",
    sub_type: "pmi",
    exchange: "pmi",
    country: "unknown",
  },
  {
    unique_identifier: "mac_man_new_export_orders",
    code: "mac_man_new_export_orders",
    name: "Manufacturing New Export Orders Index",
    type: "macro",
    sub_type: "pmi",
    exchange: "pmi",
    country: "unknown",
  },
];

export const darkThemeModal = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "#ooo",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#ccc",
    width: "80%", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#444",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
};

export const modalDarkTheme = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50vh",
  },
  modalContent: {
    backgroundColor: "#343a40",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#000",
    width: "80%", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#000",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
};

export const tickerPattern = {
  code: {
    unique_identifier: null, // You can set a unique id
    isDataLoading: true, // You can set a unique id
    id: null,
    code: null,
    name: null,
    type: null,
    sub_type: null,
    exchange: null,
    country: null,
    isPrimary: false,
    shouldDisplay: true,
    min_date: null,
    max_date: null,
    data: [],
    settings: {
      source: null,
      type: "line",
      style: defaultGraphStyle,
    },
  },
};

export const defaultSelectedTickers = {
  HDFCBANK: {
    unique_identifier: "HDFCBANK", // You can set a unique id
    isDataLoading: true, // You can set a unique id
    code: "HDFCBANK",
    name: "Hdfc Bank",
    type: "Common Stock",
    sub_type: "ohlc", // Set sub_type if required
    exchange: "NSE",
    country: "India",
    isPrimary: true, // Example setting to true
    shouldDisplay: true,
    min_date: null,
    max_date: null,
    data: [], // Populate with actual data if available
    settings: {
      source: "adjusted_close", // Example source
      type: "line",
      style: {
        lineType: "solid",
        color: "#315bbc", // Example color for the chart
        opacity: "1",
        width: "2", // Example width for line style
        priceScalePosition: "left", // Example: price scale on the right
        crosshairColor: "#00ff00", // Crosshair color
        crossHairMarkerVisible: true, // Show crosshair marker on hover
        priceLineVisible: true, // Show last price line
        lastValueVisible: true, // Show last value on the price scale
        gridLineColor: "#f0f0f0", // Grid line color
        showTitleOnPriceScale: true,
      },
    },
  },
};

export const graphDateFormat = "YYYY-MM-DD";

export const tickerCategoryList = [
  "All",
  "Currency",
  "ETF",
  "Common Stock",
  "Futures",
  "Commodity",
  "INDEX",
  "Bond",
  "macro",
  // "Custom Indicators",
];
